<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-page-nodata">
      <div v-if="title" class="no-data-sub-title">
        {{title}} <wy-page-tooltip />
      </div>
      <div v-else-if="currentPageInfo && currentPageInfo.title" class="no-data-sub-title">
        {{currentPageInfo.title}} <wy-page-tooltip v-if="!isC1Interactions" />
      </div>
      <div class="no-data-body">
        <div class="no-data-icon"></div>
        <div class="no-data-title">{{$t('noDataFound.title')}}</div>
        <div class="no-data-content">
          <div class="content-text">
            {{$t('noDataFound.message')}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import wyPageTooltip from '../components/widgets/wy-page-tooltip.vue'

export default Vue.extend({
  name: 'wy-page-nodata',
  props: {
    title: {
      // optional title
      type: String,
      default: ''
    },
  },
  components: {
    'wy-page-tooltip': wyPageTooltip
  },

  computed: {
    ...mapGetters(['config', 'currentPageInfo', 'isC1Interactions']),
  }
});
</script>

<style lang="scss">
.wy-page-nodata {
  display: flex;
  flex-direction: column;
  height: 100%;

  .no-data-small-title {
    font-size: 14px;
  }

  .no-data-sub-title {
    color: var(--site-font-primary-color);
    font-size: 25px;
    font-weight: 600;
  }

  .no-data-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80%;

    .no-data-icon {
      display: block;
      border: none;
      height: 155px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-image: url(../assets/icons/icon_no_data_new.svg);
    }
    .no-data-title {
      width: 100%;
      margin-top: 10px;
      text-align: center;
      font-size: 21px;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 600;
    }
    .no-data-content {
      width: 100%;
      line-height: 22px;
      font-size: 14px;
      text-align: center;
      color: #4B5158 !important;
      
      .content-text {
        width: 350px;
        font-weight: 500;
        text-align: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-top: 20px;
      }
    }
  }


}
</style>